import { render, staticRenderFns } from "./SubParser.vue?vue&type=template&id=bb2c25c2&scoped=true"
import script from "./SubParser.vue?vue&type=script&lang=js"
export * from "./SubParser.vue?vue&type=script&lang=js"
import style0 from "./SubParser.vue?vue&type=style&index=0&id=bb2c25c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2c25c2",
  null
  
)

export default component.exports